<template>
  <section class="lg-img-section">
    <h2>{{ title }}</h2>
    <div class="img-list">
      <LsImage
        v-for="img in imgs"
        :key="img.id"
        :src="img.src"
        :thumb-src="img.thumbSrc"
        :caption="img.caption"
        show-resize
      />
    </div>
  </section>
</template>
<script>
import VueTypes from 'vue-types';
import { LsImage } from '@/components/common';

export default {
  name: 'LgImgsSection',
  components: { LsImage },
  props: {
    title: {
      type: VueTypes.string.required,
      required: true,
    },
    imgs: {
      type: VueTypes.array.required,
      required: true,
    },
  },
};
</script>
<style lang="scss">
.lg-img-section {
  h2 {
    margin-bottom: 2rem;
  }
  .img-list {
    display: flex;
    .ls-image ~ .ls-image {
      margin-left: 2rem;
    }
  }
}
</style>
